import AdminActions from './admin-actions';

const AdminHomeTableRowCaseSlider = ({companyName ,companyDescription, companyLogo  }) =>{

    return(
         
             
        <tr>
            <td>{companyName}</td>
            <td>{companyDescription}</td>
            <td>{companyLogo}</td>
            <td><AdminActions/></td>
         </tr>
         
  
    );
   
}
export default AdminHomeTableRowCaseSlider;


